import { ContactPageTypes, MetaTagsProps } from "@/types";
import { BUSINESS_NAME, OG_PATH, WEBSITE_URL } from "@/content";

export const metaTagsContact: MetaTagsProps = {
  title: `Contact ${BUSINESS_NAME} | Security Services Sydney`,
  description:
    "Contact Ozy Wide Group for CCTV, alarm systems, intercoms, access control, security guards, mobile patrols, fire alarm support and security cabling across Sydney.",
  keywords:
    "contact Ozy Wide Group, security services Sydney contact, CCTV installation Sydney, alarm systems Sydney, hire security guards Sydney",
  url: `${WEBSITE_URL}/contact/`,
  ogImage: `${OG_PATH}page-contact.jpg`,
  type: "website",
};

export const contactPageContent: ContactPageTypes = {
  title: `Contact ${BUSINESS_NAME}`,
  description:
    "Tell us about your property, site, system or security concern and Ozy Wide Group will help with the next practical step.",
  images: [],
};
